import { useEffect, useState } from "react";
import { Box, IconButton, List, ListItem, Typography } from "@mui/material";
import { CurrentWeekLogsInterface } from "../../interface/currentWeekLogsInterface";
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import axiosInstance from "../../services/axios-instance";
import { DELETE_LOG } from "../../services/endpoints";
import { DataContext } from "../../context/data-provider";
import React, { useContext } from "react";
import { WEEKLY_LOGS_URL } from "../../services/endpoints";
import CloseIcon from "@mui/icons-material/Close";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import TextWithShowMore from "./TextWithShowMore";
import { useTheme, useMediaQuery } from '@mui/material';
import Fab from '@mui/material/Fab';
import HomeIcon from '@mui/icons-material/Home';
interface DayProps {
    weekdayName: string;
    weekDayDate: string;
    currentWeekLogs: CurrentWeekLogsInterface[];
    selectedItemIndices: number[];
    i: number;
    showInputForm: boolean;
    setShowInputForm: React.Dispatch<React.SetStateAction<boolean>>;
    setOpenedDateTrackerForm: React.Dispatch<React.SetStateAction<string>>;
    setCurrentWeekLogs: React.Dispatch<
        React.SetStateAction<CurrentWeekLogsInterface[]>
    >;
    selectedWeek: number;
    selectedYear: number;
    setEditTaskDetails: React.Dispatch<
        React.SetStateAction<CurrentWeekLogsInterface | null>
    >;
    hideEditDeleteFunctionality?: boolean;
    firstDayOfWeek: Date;
    toggleHomeOffice: (date : any) => void;
    isHomeOfficeDay: (date: string) => boolean
}

const DailyTasks = ({
    weekdayName,
    weekDayDate,
    currentWeekLogs,
    selectedItemIndices,
    i,
    showInputForm,
    setShowInputForm,
    setOpenedDateTrackerForm,
    setCurrentWeekLogs,
    setEditTaskDetails,
    hideEditDeleteFunctionality = false,
    firstDayOfWeek,
    toggleHomeOffice,
    isHomeOfficeDay
}: DayProps) => {
    const { currentUser } = useContext(DataContext);
    const [haveTasks, setHaveTasks] = useState(false);
    const filteredData = currentWeekLogs.filter(
        (obj) => obj.date === weekDayDate
    );
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteLogId, setDeleteLogId] = useState<number | null>(null);
    const [isWide, setIsWide] = useState(window.innerWidth > 600);

    const handleDeleteClick = (logId: number) => {
        setDeleteLogId(logId);
        setOpenDeleteDialog(true);
    };

    const handleEditClick = (task: CurrentWeekLogsInterface) => {
        setEditTaskDetails(task);
        setShowInputForm(true);
        setOpenedDateTrackerForm(weekDayDate);
    };

    const handleDeleteConfirm = async () => {
        if (deleteLogId !== null) {
            const response = await axiosInstance.delete(
                DELETE_LOG(deleteLogId)
            );

            if (response.status !== 204) {
                console.error("Error deleting log");
                return;
            }
        }

        if (currentUser.id) {
            const updatedResponse = await axiosInstance.get(
                WEEKLY_LOGS_URL(currentUser.id, firstDayOfWeek.toString())
            );
            setCurrentWeekLogs(updatedResponse.data.data);
        }

        // Clear the delete state
        setDeleteLogId(null);
        setOpenDeleteDialog(false);
    };

    const handleDeleteCancel = () => {
        // Clear the delete state
        setDeleteLogId(null);
        setOpenDeleteDialog(false);
    };

    useEffect(() => {
        if (filteredData.length > 0) {
            setHaveTasks(true);
        } else {
            setHaveTasks(false);
        }
    }, [filteredData.length]);

    useEffect(() => {
        const handleResize = () => {
          setIsWide(window.innerWidth > 600);
        };
    
        window.addEventListener('resize', handleResize);
        
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);

    const convertMinutesToDurationString = (minutes: number) =>
        `${Math.floor(minutes / 60)}h${
            minutes % 60 !== 0 ? `${minutes % 60}m` : ""
        }`;

    return (
        <Box sx={{ width: "100%" }}>
            <Box
                sx={{
                    display: "flex",
                    gap: 1,
                    justifyContent: "space-between",
                }}
            >
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                {!hideEditDeleteFunctionality && (
                    <Box className={`fab ${isHomeOfficeDay(weekDayDate) ? "home_active" : ""}`}                    onClick={() => toggleHomeOffice(weekDayDate)}>
                        <Fab aria-label="like">
                            <HomeIcon />
                        </Fab>
                    </Box>
                )}
                <Typography
                    component="h1"
                    variant="subtitle1"
                    sx={{
                        fontWeight: 600,
                        textTransform: "capitalize",
                        color: "primary.light",
                    }}
                >
                    {weekdayName}{isWide ? (`, ${weekDayDate}`):("")}
                </Typography>
                </div>
                {!hideEditDeleteFunctionality && (
                <IconButton
                        onClick={() => {
                            setShowInputForm(!showInputForm);
                            setOpenedDateTrackerForm(weekDayDate);
                        }}
                    >
                        <MoreTimeIcon fontSize="small" />
                    </IconButton>
                )}
            </Box>
            <Box>
                {haveTasks && selectedItemIndices?.includes(i) && (
                    <List sx={{ mr: "-36px" }}>
                        {filteredData.map((task) => (
                            <Box
                                key={task.id}
                                sx={{
                                    backgroundColor: "white",
                                    padding: "8px",
                                    borderRadius: "4px",
                                    display: "flex",
                                    marginBottom: "8px",
                                    flexDirection: isMobile ? "column" : "row"
                                }}
                            >
                                <ListItem sx={{ fontSize: "14px" }}>
                                    {/* <p>Description: {task.description}</p> */}
                                    <TextWithShowMore text={task.description} />
                                </ListItem>
                                <ListItem sx={{ width: "200px" }}>
                                    {task.client_id && (
                                        <span>{task.client_name}</span>
                                    )}
                                </ListItem>
                                <ListItem
                                    sx={{
                                        mt: 0.5,
                                        width: "auto",
                                        minWidth: "70px",
                                    }}
                                >
                                    {convertMinutesToDurationString(
                                        task.duration
                                    )}
                                </ListItem>
                                {!hideEditDeleteFunctionality && (
                                    <ListItem sx={{ width: "96px" }}>
                                        <Button
                                            sx={{
                                                minWidth: "auto",
                                                padding: "4px",
                                            }}
                                            onClick={() =>
                                                handleEditClick(task)
                                            }
                                        >
                                            <EditOutlinedIcon />
                                        </Button>
                                        <Button
                                            sx={{
                                                minWidth: "auto",
                                                padding: "4px",
                                            }}
                                            onClick={() =>
                                                handleDeleteClick(task.id)
                                            }
                                        >
                                            <CloseIcon />
                                        </Button>
                                    </ListItem>
                                )}
                            </Box>
                        ))}
                    </List>
                )}
                {!haveTasks && selectedItemIndices?.includes(i) && (
                    <List>
                        <ListItem
                            sx={{
                                color: "primary.light",
                                fontWeight: 500,
                            }}
                        >
                            No Entries for this day.
                        </ListItem>
                    </List>
                )}
            </Box>
            <Dialog open={openDeleteDialog} onClose={handleDeleteCancel}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    Are you sure you want to delete this log?
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteCancel} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteConfirm} color="secondary">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default DailyTasks;
